import DefaultModal from 'components/common/DefaultModal';
import { FORMAT_TIME } from 'constants/days';
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import moment from 'moment';
import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { appointmentTypeOptionsArray } from 'types/transaction';
import { metersToMiles } from 'utils';

import CardActionButton from '../../../AppointmentsTabs/CardActionButton';
import { getPaymentText } from '../../../AppointmentsTabs/helpers';
import AppointmentDetail from '../../AppointmentDetail';
import CancelAppointmentForm from '../../CancelAppointmentForm';
import ContactNLabelButtons from '../../ContactNLabelButtons';
import { useCommonActionButtonsForAppointments } from '../../helpers';
import { INotaryAppointmentType } from '../../types';

const FutureAppointment: React.FC<INotaryAppointmentType> = ({
  appointment,
  transactionTypesData,
  refetchAppointmentData,
}) => {
  const unreadMessageCount = appointment.chatRoom?.unreadMessagesCount;

  const userId = useCurrentLoggedInUser().id;
  const type = appointmentTypeOptionsArray.find((sc) => sc.value === appointment?.type)?.label || '';
  // const appointmentAddress = appointment.address;
  const appointmentStartTime = moment(appointment.date).format(FORMAT_TIME).toString();
  const appointmentDuration = (appointment.duration || 0) / 3600;
  const appointmentEndTime = moment(appointment.date).add(appointmentDuration, 'h').format(FORMAT_TIME).toString();

  const isAppointmentAccepted = appointment.notary?.id === userId;

  const {
    acceptAppointmentClick,
    contactClick,
    cancelAppointmentClick,
    rejectAppointmentClick,
    completeAppointmentClick,
    markAppointmentAsCompleted,
    modalType,
    closeModal,
    appointmentCardClick,
    generateShippingLabelLoading,
    shippingLabelClick,
  } = useCommonActionButtonsForAppointments({ refetch: refetchAppointmentData, appointment, transactionTypesData });

  const ownedAssignment = appointment.assignments?.find((assignment) => assignment.notary.id === userId);

  return (
    <>
      <DefaultModal
        props={{ title: `Appointment Detail - ${type}`, visible: modalType === 'detail', onCancel: closeModal }}>
        <AppointmentDetail appointment={appointment} transactionTypesData={transactionTypesData} />
      </DefaultModal>
      <DefaultModal props={{ title: `Cancel Appointment`, visible: modalType === 'cancel', onCancel: closeModal }}>
        <CancelAppointmentForm assignment={ownedAssignment} closeModal={closeModal} />
      </DefaultModal>
      <SweetAlert
        show={modalType === 'complete-appointment'}
        warning
        showCancel
        confirmBtnText='Mark complete'
        confirmBtnBsStyle='info'
        cancelBtnText='Cancel'
        title='Mark this appointment as completed?'
        onConfirm={() => {
          markAppointmentAsCompleted(appointment);
        }}
        onCancel={closeModal}
        focusConfirmBtn
      />
      <div
        className='gx-d-flex gx-justify-content-between gx-w-100 common-appointment-by-day-single'
        onClick={appointmentCardClick}>
        <div className='common-appointment-info'>
          <div className='common-appointment-info-main'>
            <div className='gx-font-weight-bold'>
              {appointmentStartTime} - {appointmentEndTime} ({appointmentDuration} hour
              {appointmentDuration > 1 ? 's' : ''})
            </div>
            <div className='description'>Notary Appointment</div>
            {isAppointmentAccepted && (
              <ContactNLabelButtons
                shippingLabelLoading={generateShippingLabelLoading}
                containerClassName='contact-label-button desktop-only'
                contactClick={contactClick}
                shippingLabelClick={shippingLabelClick}
                unreadMessageCount={unreadMessageCount}
                appointment={appointment}
              />
            )}
          </div>
          <div className='common-appointment-info-extra'>
            <div>
              <span className='gx-font-weight-medium'>Distance:</span>
              <span> {metersToMiles(appointment.distance || 0).toFixed(1)} miles</span>
            </div>
            <div>
              <span className='gx-font-weight-medium'>Payment:</span>
              <span> ${getPaymentText(appointment, transactionTypesData).notaryPrice}</span>
            </div>
            {isAppointmentAccepted && (
              <ContactNLabelButtons
                shippingLabelLoading={generateShippingLabelLoading}
                containerClassName='contact-label-button mobile-only'
                contactClick={contactClick}
                shippingLabelClick={shippingLabelClick}
                unreadMessageCount={unreadMessageCount}
                appointment={appointment}
              />
            )}
          </div>
          <div className='appointment-info-action-buttons'>
            <CardActionButton
              appointment={appointment}
              acceptAppointmentClick={acceptAppointmentClick}
              rejectAppointmentClick={rejectAppointmentClick}
              cancelAppointmentClick={cancelAppointmentClick}
              completeAppointmentClick={completeAppointmentClick}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default FutureAppointment;
